import * as Cookies from 'js-cookie';

export default {
  initialized: false,
  bar: null,
  barX: null,
  promoVersion: null,
  noClose: true,
  hiddenFlag: 'announcement-bar--hidden',
  noCloseFlag: 'announcement-bar--no-close',
  cookieName: 'promoBarDisabledV1',

  _bindEvents() {
    this.barX.addEventListener( 'click', e => this.hide() );
  },

  init() {
    this.bar = document.querySelector('#announcement-bar');

    if (this.bar) {
      this.barX = document.querySelector('#announcement-bar-close');
      this.promoVersion = this.bar.getAttribute('data-promo-version');
      this.noClose = this.bar.getAttribute('data-no-close') == 1 ? true : false;

      if (this.noClose) this.disableClose();
      this.show();

      this._bindEvents();

      this.initialized = true;
    }
  },

  toggle(forceHide) {
    if ( this.isDisabled() ) forceHide = true;
    if ( typeof forceHide === "undefined" ) {
      this.bar.classList.toggle(this.hiddenFlag);
    } else if (forceHide) {
      this.bar.classList.add(this.hiddenFlag);
    } else {
      this.bar.classList.remove(this.hiddenFlag);
    }
  },

  show() {
    if (!this.isDisabled()) {
      this.bar.classList.remove(this.hiddenFlag);
    }
  },

  hide() {
    this.bar.classList.add(this.hiddenFlag);
    this.setNoShowCookie();
  },

  getHeight() {
    if (this.isHidden()) return 0;
    return this.bar.offsetHeight;
  },

  disableClose() {
    this.bar.classList.add(this.noCloseFlag);
  },

  resetNoShowCookie() {
    Cookies.remove(this.cookieName);
  },

  setNoShowCookie(days=1) {
    Cookies.set(this.cookieName, this.promoVersion, { expires: days });
  },

  isDisabled() {
    if ( this.noClose ) return false;
    return (Cookies.get(this.cookieName) == this.promoVersion);
  },

  isHidden() {
    return this.classList.contains(this.hiddenFlag);
  },
}
